/**
 * 付费 / 选套餐（注册 signupAndPayment + Management Plans And Pricing）。
 * STATSIG.PAYMENT.PAY → PAYMENT_PAY
 *
 * 页面访问仍用 PAGE_VIEW：
 * - 注册选套餐 signup_plan
 * - 注册付款 signup_payment
 * - Management Plans And Pricing mgmt_plans_and_pricing
 *
 * 正在用：
 * - 确认套餐（注册 Activate / Management Upgrade）
 * - 付款结果（成功或失败都打，算成功率）
 * - Plan details、Schedule demo（仅 Management）
 */
export enum PaymentEvent {
    /**
     * 确认套餐。
     * value 与 metadata.plan 相同：explorer|individual|business
     */
    PLAN = 'PAYMENT_PLAN',
    /**
     * 付款结果（有结果才打，不要在点 Pay 时打）。
     * value 与 metadata.plan 相同：individual|business
     * 属性 cycle=monthly|annually
     * 属性 result=success|fail
     * 属性 source=signup|management
     */
    PAY = 'PAYMENT_PAY',
    /**
     * 点 Plan details。
     * value 与 metadata.plan 相同：explorer|individual|business
     */
    PLAN_DETAILS = 'PAYMENT_PLAN_DETAILS',
    /**
     * Schedule demo。
     * value 与 metadata.source 相同：enterprise|loan_product
     */
    SCHEDULE_DEMO = 'PAYMENT_SCHEDULE_DEMO',
}

export type PaymentResult = 'success' | 'fail'
export type PaymentSource = 'signup' | 'management'

/** 套餐 id / key → 埋点 plan 名 */
const PAYMENT_PLAN_BY_ID: Record<string, string> = {
    starter: 'explorer',
    explorer: 'explorer',
    originator: 'individual',
    individual: 'individual',
    business: 'business',
}

export function paymentPlanValue(planId: string): string | undefined {
    return PAYMENT_PLAN_BY_ID[planId]
}

/** 年付 true → annually，月付 false → monthly */
export function paymentPayCycle(isAnnual: boolean): 'annually' | 'monthly' {
    return isAnnual ? 'annually' : 'monthly'
}

/**
 * PAYMENT_PAY 的 value + metadata。免费套餐返回 null。
 * 成功率：count(result=success) / count(PAYMENT_PAY)
 */
export function paymentPayProps(
    planId: string,
    isAnnual: boolean,
    result: PaymentResult,
    source: PaymentSource
): {
    value: string
    metadata: {
        plan: string
        cycle: 'annually' | 'monthly'
        result: PaymentResult
        source: PaymentSource
    }
} | null {
    const plan = paymentPlanValue(planId)
    if (!plan || plan === 'explorer') return null
    return {
        value: plan,
        metadata: {
            plan,
            cycle: paymentPayCycle(isAnnual),
            result,
            source,
        },
    }
}
